export default "__VITE_ASSET__qVIbm3ii__"